var _style, _path, _line, _line2, _line3, _path2, _circle, _path3, _path4, _path5, _path6, _line4, _line5, _line6, _path7, _circle2, _path8, _path9, _path0, _path1, _line7, _line8, _line9, _path10, _circle3, _path11, _path12, _path13, _path14, _path15, _path16, _line0, _line1, _line10, _path17, _circle4, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCircleFlare3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.64,6.86V3.98c3.85,2.32,7.08,5.55,9.4,9.4h-2.86",
    shapeRendering: "optimizeQuality"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.01,
    y1: 1.5,
    x2: 30.01,
    y2: 4.35,
    shapeRendering: "optimizeQuality"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.64,
    y1: 6.86,
    x2: 44.98,
    y2: 9.17,
    shapeRendering: "optimizeQuality"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.16,
    y1: 13.38,
    x2: 50.85,
    y2: 15.03,
    shapeRendering: "optimizeQuality"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.09,21.08c-1.81-14.44,0.65-18.8,0.65-18.8s-6.65,2.57-18.8,0.65",
    shapeRendering: "optimizeQuality"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.1,
    cy: 5.91,
    r: 1.22,
    shapeRendering: "optimizeQuality"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,17.29",
    shapeRendering: "optimizeQuality"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.69,30",
    shapeRendering: "optimizeQuality"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.38,21.97l-4.68-4.68c-1.57-2.27-3.55-4.25-5.84-5.84l-5.81-5.81",
    shapeRendering: "optimizeQuality"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.38,13.38H4.5c2.32-3.85,5.55-7.08,9.4-9.4v2.86",
    shapeRendering: "optimizeQuality"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.02,
    y1: 30,
    x2: 4.87,
    y2: 30,
    shapeRendering: "optimizeQuality"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.38,
    y1: 13.38,
    x2: 9.69,
    y2: 15.03,
    shapeRendering: "optimizeQuality"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.89,
    y1: 6.86,
    x2: 15.55,
    y2: 9.17,
    shapeRendering: "optimizeQuality"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,2.92C7.16,4.74,2.79,2.27,2.79,2.27s2.57,6.65,0.65,18.8",
    shapeRendering: "optimizeQuality"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.43,
    cy: 5.91,
    r: 1.22,
    shapeRendering: "optimizeQuality"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.81,10.31",
    shapeRendering: "optimizeQuality"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.52,6.32",
    shapeRendering: "optimizeQuality"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.49,5.63l-4.68,4.68c-2.27,1.57-4.25,3.55-5.84,5.84l-5.81,5.81",
    shapeRendering: "optimizeQuality"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.89,53.14v2.88c-3.85-2.32-7.08-5.55-9.4-9.4h2.86",
    shapeRendering: "optimizeQuality"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.52,
    y1: 58.5,
    x2: 30.52,
    y2: 55.65,
    shapeRendering: "optimizeQuality"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.89,
    y1: 53.14,
    x2: 15.55,
    y2: 50.83,
    shapeRendering: "optimizeQuality"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.38,
    y1: 46.62,
    x2: 9.69,
    y2: 44.97,
    shapeRendering: "optimizeQuality"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.44,38.92c1.81,14.44-0.65,18.8-0.65,18.8s6.65-2.57,18.8-0.65",
    shapeRendering: "optimizeQuality"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.43,
    cy: 54.09,
    r: 1.22,
    shapeRendering: "optimizeQuality"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.83,42.71",
    shapeRendering: "optimizeQuality"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.84,30",
    shapeRendering: "optimizeQuality"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.15,38.03l4.68,4.68c1.57,2.27,3.55,4.25,5.84,5.84l5.81,5.81",
    shapeRendering: "optimizeQuality"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.16,46.62h2.88c-2.32,3.85-5.55,7.08-9.4,9.4v-2.86",
    shapeRendering: "optimizeQuality"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.01,58.5c15.74,0,28.5-12.76,28.5-28.5S45.75,1.5,30.01,1.5h0.5C14.78,1.5,2.02,14.26,2.02,30 s12.76,28.5,28.5,28.5",
    shapeRendering: "optimizeQuality"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.01,55.65c14.16,0,25.65-11.49,25.65-25.65S44.18,4.35,30.01,4.35h0.5C16.35,4.35,4.87,15.84,4.87,30 s11.49,25.65,25.65,25.65",
    shapeRendering: "optimizeQuality"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 58.51,
    y1: 30,
    x2: 55.66,
    y2: 30,
    shapeRendering: "optimizeQuality"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.16,
    y1: 46.62,
    x2: 50.85,
    y2: 44.97,
    shapeRendering: "optimizeQuality"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.64,
    y1: 53.14,
    x2: 44.98,
    y2: 50.83,
    shapeRendering: "optimizeQuality"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.94,57.08c14.44-1.81,18.8,0.65,18.8,0.65s-2.57-6.65-0.65-18.8",
    shapeRendering: "optimizeQuality"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.1,
    cy: 54.09,
    r: 1.22,
    shapeRendering: "optimizeQuality"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.72,49.69",
    shapeRendering: "optimizeQuality"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.01,53.68",
    shapeRendering: "optimizeQuality"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.04,54.37l4.68-4.68c2.27-1.57,4.25-3.55,5.84-5.84l5.81-5.81",
    shapeRendering: "optimizeQuality"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircleFlare3);
export default __webpack_public_path__ + "static/media/double_circle_flare_3.0a8ec37b23b9ae05db9c3430b5b41fff.svg";
export { ForwardRef as ReactComponent };